import { render, staticRenderFns } from "./uploadImgShareImg.vue?vue&type=template&id=140528ae&scoped=true"
import script from "./uploadImgShareImg.vue?vue&type=script&lang=js"
export * from "./uploadImgShareImg.vue?vue&type=script&lang=js"
import style0 from "./uploadImgShareImg.vue?vue&type=style&index=0&id=140528ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140528ae",
  null
  
)

export default component.exports